// extracted by mini-css-extract-plugin
module.exports = {"btn":"substitution-btn_btn__1eELW"};